import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectIntersemanalDataAnalisada,
  selectIntersemanalCenario,
} from 'redux/reducers/relatoriosIntersemanalReducer';
import { IntersemanalSecaoParams } from 'types/Relatorios/Intersemanal';

/**
 * Deriva os params compartilhados das abas Intersemanal (`data_rodada` ISO + `cenario`)
 * a partir do slice. `useMemo` sobre os primitivos `[ano, mes, dia, cenario]` (NÃO sobre
 * o objeto do selector, que retorna nova ref a cada render) e devolve uma referência
 * estável enquanto os valores não mudarem — evita refetch desnecessário do RTK Query.
 */
export default function useIntersemanalSecaoParams(): IntersemanalSecaoParams {
  const { ano, mes, dia } = useSelector(selectIntersemanalDataAnalisada);
  const cenario = useSelector(selectIntersemanalCenario);

  return useMemo(() => {
    const mm = String(mes).padStart(2, '0');
    const dd = String(dia).padStart(2, '0');
    return { data_rodada: `${ano}-${mm}-${dd}`, cenario };
  }, [ano, mes, dia, cenario]);
}
